export type FocusTimeSlot = {
  id: string;
  startAt: string;
  endAt: string;
};

export type FocusTimeSchedulePayloadItem = {
  id?: string;
  startAt?: string;
  endAt?: string;
};

export type FocusTimeSlotsPayload = FocusTimeSchedulePayloadItem[];

export type SaveFocusTimeSlotsOptions = Readonly<{
  showErrorToast?: boolean;
  showSuccessToast?: boolean;
}>;

export enum FocusTimeHandle {
  Start = 'start',
  End = 'end',
}

export type FocusTimeContextType = Readonly<{
  slots: FocusTimeSlot[];
  currentMinutes: number | null;
  minSelectableMinutes: number;
  saveSlots: (slots: FocusTimeSlot[], options?: SaveFocusTimeSlotsOptions) => Promise<void>;
}>;

export type FocusTimeState = Readonly<{
  slots: FocusTimeSlot[];
  currentMinutes: number;
}>;

export enum FocusTimeActionType {
  SetSlots = 'set-slots',
  SetCurrentMinutes = 'set-current-minutes',
}

export type FocusTimeAction =
  | Readonly<{
      type: FocusTimeActionType.SetSlots;
      payload: FocusTimeSlot[];
    }>
  | Readonly<{
      type: FocusTimeActionType.SetCurrentMinutes;
      payload: number;
    }>;
